export default __webpack_public_path__ + "static/media/WorkSans-Bold.211e83f8.woff";